import { LegalLayout } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" effective="August 11, 2026" updated="August 11, 2026">
      <section>
        <p>These terms govern your use of danelomax.com, operated by Dane Lomax, LLC, an Arizona limited liability company. By using this site you agree to them. If you do not agree, do not use the site.</p>
      </section>
      <section>
        <h2>About this site</h2>
        <p>This site describes consulting services and provides a way to contact us. Using it does not create a consulting relationship, a contract for services, or any other engagement. Services are provided only under a separate written agreement signed by both parties.</p>
      </section>
      <section>
        <h2>Not legal advice</h2>
        <p><strong>Dane Lomax, LLC is not a law firm and does not provide legal advice.</strong> Nothing on this site, and nothing said through the chat on this site, is legal advice or a legal opinion. No attorney-client relationship is created by using this site or by contacting us. Regulatory matters arising in an engagement are referred to qualified counsel, and you should retain your own counsel for questions about your legal obligations.</p>
      </section>
      <section>
        <h2>Information on this site</h2>
        <p>We aim for accuracy, but the site is provided for general information. Laws, carrier requirements, and industry practices change. We make no representation that anything here is current, complete, or applicable to your circumstances.</p>
      </section>
      <section>
        <h2>Text messages</h2>
        <p>If you opt in to receive text messages, message frequency varies and message and data rates may apply. Reply STOP to any message to stop receiving them, or HELP for assistance. Consent is not a condition of purchase or of receiving any service. Carriers are not liable for delayed or undelivered messages.</p>
      </section>
      <section>
        <h2>Acceptable use</h2>
        <p>You agree not to use this site to transmit unlawful, harassing, or infringing material; attempt to gain unauthorized access to any system; interfere with the site's operation; scrape or harvest data; or submit false information or another person's information without their permission.</p>
      </section>
      <section>
        <h2>Intellectual property</h2>
        <p>All content on this site is owned by Dane Lomax, LLC or its licensors and is protected by applicable law. You may view and print it for your own reference. You may not reproduce, distribute, or create derivative works from it without written permission.</p>
      </section>
      <section>
        <h2>Third-party links</h2>
        <p>This site may link to third-party sites. We do not control them and are not responsible for their content or practices.</p>
      </section>
      <section>
        <h2>Disclaimer of warranties</h2>
        <p><strong>This site is provided "as is" and "as available," without warranties of any kind, express or implied,</strong> including implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that the site will be uninterrupted, secure, or error-free.</p>
      </section>
      <section>
        <h2>Limitation of liability</h2>
        <p><strong>To the maximum extent permitted by law, Dane Lomax, LLC and its members, officers, and agents will not be liable for any indirect, incidental, special, consequential, exemplary, or punitive damages, or any loss of profits, revenue, data, or goodwill, arising out of your use of this site,</strong> whether based in contract, tort, or any other theory, even if advised of the possibility. Our total aggregate liability arising out of or relating to this site will not exceed one hundred U.S. dollars ($100.00).</p>
        <p>Some jurisdictions do not allow certain exclusions, so parts of this section may not apply to you.</p>
      </section>
      <section>
        <h2>Indemnification</h2>
        <p>You agree to indemnify and hold harmless Dane Lomax, LLC from any claim, loss, or expense, including reasonable attorneys' fees, arising out of your use of this site or your breach of these terms.</p>
      </section>
      <section>
        <h2>Governing law and venue</h2>
        <p>These terms are governed by the laws of the State of Arizona, without regard to its conflict-of-laws rules. Any dispute arising out of or relating to these terms or this site will be brought exclusively in the state or federal courts located in Maricopa County, Arizona, and you consent to the personal jurisdiction of those courts.</p>
      </section>
      <section>
        <h2>Severability and entire agreement</h2>
        <p>If any provision is held unenforceable, the remainder stays in effect. These terms are the entire agreement between you and Dane Lomax, LLC regarding the site.</p>
      </section>
      <section>
        <h2>Changes</h2>
        <p>We may update these terms. Changes take effect when posted, and the "last updated" date will change. Continued use after that constitutes acceptance.</p>
      </section>
      <section>
        <h2>Contact</h2>
        <p>Dane Lomax, LLC<br />12769 N 78th St<br />Scottsdale, AZ 85260<br />dane@danelomax.com<br />(480) 626-4575</p>
      </section>
    </LegalLayout>
  );
}
